import { appStaticKeyApi } from "../../config/apiConfig";
import type { StaticKeyRequestType, StaticKeyResponseType } from "./types";

export const getStaticKeys = (): Promise<StaticKeyResponseType[]> => {
  return appStaticKeyApi
    .get("/static-keys?limit=100&offset=0", {
      withCredentials: false,
    })
    .then((res) => res.data);
};

export const createStaticKey = (
  postObj: StaticKeyRequestType,
): Promise<StaticKeyResponseType> => {
  return appStaticKeyApi
    .post("/static-keys", postObj, {
      withCredentials: false,
    })
    .then((res) => res.data);
};

export const updateStaticKey = (
  postObj: StaticKeyRequestType,
  id: number,
): Promise<StaticKeyResponseType> => {
  return appStaticKeyApi
    .put(`/static-keys/${id}`, postObj, {
      withCredentials: false,
    })
    .then((res) => res.data);
};

export const deleteStaticKey = (id: number) => {
  return appStaticKeyApi
    .delete(`/static-keys/${id}`, {
      withCredentials: false,
    })
    .then(() => id);
};
